import { Skeleton, Stack, Typography } from '@mui/material'
import { useGetAuthUser } from '@/service-library/hooks/auth-user'
import UserAvatar from '@/components/avatars/UserAvatar'

type UserTagPopoverProps = {
  userId: string
  name: string
  open: boolean
}

export default function UserTagPopover({
  userId,
  name,
  open,
}: UserTagPopoverProps) {
  const { user, isPending, isError } = useGetAuthUser({
    id: userId,
    enabled: open,
    retry: false,
    staleTime: Infinity,
  })

  const foundUser = isError ? undefined : user
  const displayName = foundUser?.name ?? name

  return (
    <Stack direction="row" spacing={1.5} alignItems="center">
      <UserAvatar name={displayName} loading={isPending} />
      <Stack sx={{ flex: 1, minWidth: 0 }}>
        {isPending ? (
          <>
            <Skeleton variant="text" width="60%" />
            <Skeleton variant="text" width="80%" />
          </>
        ) : (
          <>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {displayName}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ wordBreak: 'break-word' }}
            >
              {foundUser ? foundUser.email : 'User not found'}
            </Typography>
          </>
        )}
      </Stack>
    </Stack>
  )
}
